import { ChannelType } from './atendimentoEnums';

export enum SupportGroupMemberType {
  User = "User",
  Team = "Team",
  Role = "Role",
}

export interface SupportGroupMember {
  id: string;
  memberType: SupportGroupMemberType;
  userId?: string | null;
  userName?: string | null;
  teamId?: string | null;
  teamName?: string | null;
  roleId?: string | null;
  roleName?: string | null;
}

export interface SupportGroupRoutingRule {
  id: string;
  supportGroupId: string;
  name: string;
  priority: number;
  isActive: boolean;
  channelType?: ChannelType | null;
  inboxId?: string | null;
  keywordContains?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface SupportGroup {
  id: string;
  name: string;
  description?: string | null;
  color?: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  members: SupportGroupMember[];
  routingRules: SupportGroupRoutingRule[];
}

export interface SupportGroupStats {
  supportGroupId: string;
  name: string;
  color?: string | null;
  isActive: boolean;
  openConversationCount: number;
  totalConversationCount: number;
}

export interface SupportGroupMemberInput {
  memberType: SupportGroupMemberType;
  userId?: string | null;
  teamId?: string | null;
  roleId?: string | null;
}

export interface CreateSupportGroupRequest {
  name: string;
  description?: string | null;
  color?: string | null;
  isActive?: boolean;
  members?: SupportGroupMemberInput[];
}

export interface UpdateSupportGroupRequest {
  name: string;
  description?: string | null;
  color?: string | null;
  isActive: boolean;
}

export interface UpdateSupportGroupMembersRequest {
  members: SupportGroupMemberInput[];
}

export interface CreateSupportGroupRoutingRuleRequest {
  name: string;
  priority?: number;
  isActive?: boolean;
  channelType?: ChannelType | null;
  inboxId?: string | null;
  keywordContains?: string | null;
}

export interface UpdateSupportGroupRoutingRuleRequest extends CreateSupportGroupRoutingRuleRequest {}

export interface TransferConversationGroupRequest {
  supportGroupId: string;
  reason?: string | null;
}
